var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('embed',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":_vm.link,"type":"application/pdf"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }